import { render } from "./GoalsAndBudget.vue?vue&type=template&id=72576194"
import script from "./GoalsAndBudget.vue?vue&type=script&lang=js"
export * from "./GoalsAndBudget.vue?vue&type=script&lang=js"

import "./GoalsAndBudget.vue?vue&type=style&index=0&id=72576194&lang=scss&scope=true"
import "./GoalsAndBudget.vue?vue&type=style&index=1&id=72576194&lang=css"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__